import {
  CONFIG_MASTER_ENUM,
  STEP_MASTER_ENUM
} from "../../constants/constant";
import {

  paymentTimerConstantValue
} from "../../constants/timers";
import { HOME, SEND_FOLIO } from "../../routes/Paths";
import {
  checkOut,
  postPaymentToPMS,
  triggerPayment,
  GetauthorizationHistory,
  saveFolio,
} from "../../network/apiService";
import {
  formatCardExpiry,
  getConfigurationCode,
  getParametersFromLocalStorage,
  getStepMaster,
  homePageHandler,
} from "../../helpers/commonHelper";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";

import CheckoutFooter from "../../components/Layout/CheckoutFooter";
import HomePageCard from "../../components/Layout/Card/HomePageCard";
import Payment from "../../components/Payment/Payment";
import { getCheckoutData } from "../../store/Checkout/checkoutSlice";
import { getModuleConfiguration } from "../../store/Checkin/moduleConfigurationSlice";
import { getPropertyInfo } from "../../store/Checkin/Scan/propertySlice";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { postAuditLog, postStageDetails } from "../../store/stageSlice";
import useUserActivity from "../../hooks/useUserActivity";

const CheckoutPayment = () => {
  
  // Fetch isPreauth on component load
  // const [isPreauth, setIsPreauth] = useState(true); // ← manually set this to true for testing
  const [isPreauth, setIsPreauth] = useState(null);
  console.log("CheckoutPayment component loaded, isPreauth:", isPreauth);

  const { t } = useTranslation();
  const timeLimit = paymentTimerConstantValue;
  const [showModal, setShowModal] = useState(false);
  const [freezeTimer, setFreezeTimer] = useState(false);
  
  const [paymentToggle, setPaymentToggle] = useState(false);
  const [timerValue, setTimerValue] = useState(timeLimit);
  const [restartTimer, setRestartTimer] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [successLoader, setSuccessLoader] = useState(false);

  //const [showPreAuthModal, setShowPreAuthModal] = useState(isPreauth);
  const [erroModalData, setErrorModalData] = useState({
    toggleError: false,
    errorMessage: "",
  });

  const [erroModalData2, setErrorModalData2] = useState({
    toggleError: false,
    errorMessage: "",
  });
  const [erroModalData3, setErrorModalData3] = useState({
    toggleError: false,
    errorMessage: "",
  });
  const [erroModalData4, setErrorModalData4] = useState({
    toggleError: false,
    errorMessage: "",
  });
  const token = getParametersFromLocalStorage("token");
  const totalAmount = localStorage.getItem("DueAmount");
  const navigate = useNavigate();
  const propertyData = useSelector(getPropertyInfo);
  const userData = useSelector(getCheckoutData);
  const deviceConfig = localStorage.getItem("PaymentDevice");
  const [i, setI] = useState(0);

  const stepMaster = useSelector((state) => getModuleConfiguration(state));
  const steps = getStepMaster(stepMaster, STEP_MASTER_ENUM.FOLIO_PAGE);
  const configs = steps?.configs;
  const isSettleByPMS = getConfigurationCode(
    configs,
    CONFIG_MASTER_ENUM.SETTLE_BY_PMS
  );

  const stepsPay = getStepMaster(stepMaster, STEP_MASTER_ENUM.PAYMENT_PAGE);
  const isTogglePay = getConfigurationCode(
    stepsPay?.configs,
    CONFIG_MASTER_ENUM.TOGGLE_PAY
  );
  // useEffect(() => {
  //   const fetchPreauthStatus = async () => {
  //     try {
  //       const ResNameID = localStorage.getItem("reservationNameID");
  //       console.log("**** Reservation NameID **** " + ResNameID);

  //       const newObj1 = {
  //         ReservationNameID: ResNameID,
  //       };

  //       const Historyresponse = await GetauthorizationHistory(newObj1, token);

  //       console.log(
  //         "**** Reservation Authorization HistoryResponse **** " +
  //           Historyresponse.data.result
  //       );

  //       const result = Historyresponse.data.result === true;
  //       setIsPreauth(result);

  //       console.log(
  //         "**** Reservation Authorization response message **** " +
  //           Historyresponse.data.message
  //       );
  //     } catch (error) {
  //       console.error("Error fetching authorization history", error);
  //       setIsPreauth(false); // fallback if error
  //     }
  //   };

  //   fetchPreauthStatus();
  // }, [token]); // add token as dependency if it's dynamic

  const resetTimerAndClosePopUp = () => {
    if (!timerValue) {
      setTimerValue(timeLimit);
    }
    setRestartTimer(true);
    setShowModal(false);
  };

  const timerCounter = (value) => {
    setTimerValue(value);
  };

  const openModal = () => {
    setShowModal(true);
  };

  const stopTimer = () => {
    setRestartTimer(false);
  };

  const closeErrorModal = () => {
    setErrorModalData((state) => ({
      ...state,
      toggleError: false,
      errorMessage: "",
    }));
  };

  const closeErrorModal2 = () => {
    setErrorModalData2((state) => ({
      ...state,
      toggleError: false,
      errorMessage: "",
    }));
  };

  const closeErrorModal3 = () => {
    setErrorModalData3((state) => ({
      ...state,
      toggleError: false,
      errorMessage: "",
    }));
  };

  const closeErrorModal4 = () => {
    setErrorModalData4((state) => ({
      ...state,
      toggleError: false,
      errorMessage: "",
    }));
  };
  const incrementI = () => {
    setI(i + 1);
  };
  const enablePaymentToggle = async () => {
    if (isTogglePay === true) {
      setPaymentToggle(true);
    } else {
      paymentTypeHandler();
    }
  };



  const userCheckOut = async () => {
    try {
      setLoading3(true);

      const confirmNo = localStorage.getItem("confirmationNo");
      const ReservationNameID = localStorage.getItem("reservationNameID");

      const checkinData = {
        confirmationNo: confirmNo,
        reservationNameID: ReservationNameID,
        roomNumber: userData?.roomNo,
        isNoPost: true,
        isPreAuthSpecified: false,
        preAuthAmount: 0,
        // payment: {
        //   vendor: "Q3",
        //   paymentType: "CA",
        //   terminalId: "100010001",
        //   trxNumber: "txn98980098",
        //   trxAmount: 10,
        //   currency: "AED",
        //   workStation: "KIOSK1",
        //   orderId: "OR1090090",
        // },
      };

      const RegCard = {
        reservationID: 0,
        confirmationNo: confirmNo,
        reservationNameID: ReservationNameID,
        signatureBase64: "-", //use saved signature in DB
        documentType: "FOLIO",
      };
      var folioSaved = saveFolio(RegCard, token);

      const response2 = await checkOut(checkinData, token);
      if (response2.data?.result === true) {
        setSuccessLoader(true);
        setTimeout(async () => {
          setLoading3(false);
          setSuccessLoader(false);
          await folioSaved;
          navigate(SEND_FOLIO, { replace: true });
        }, 1500);
        return;
      }
    } catch (error) {
      setLoading3(false);
      setErrorModalData3((state) => ({
        ...state,
        toggleError: true,
        errorMessage: error.message,
      }));
      console.log(error);
      return;
    }
    return;
  };

  const doCheckout = async (data) => {
    const confirmNo = localStorage.getItem("confirmationNo");
    const ReservationNameID = localStorage.getItem("reservationNameID");

    const checkOutData = {
      confirmationNo: confirmNo,
      reservationNameID: ReservationNameID,
      data, // paymentType,
    };
    const response2 = await checkOut(checkOutData, token);
    // 
    if (response2?.data?.result === true) {
      setPaymentToggle(false);
      setSuccessLoader(true);
      var folioSaved = null;
      try {
        if (data === true) {
          const RegCard = {
            reservationID: 0,
            confirmationNo: confirmNo,
            reservationNameID: ReservationNameID,
            signatureBase64: "-", //use saved signature in DB
            documentType: "FOLIO",
          };
          folioSaved = saveFolio(RegCard, token);
        }
      } catch (error) {
        console.error("Error saving folio:", error);
      }
      setTimeout(async () => {
        setLoading3(false);
        setSuccessLoader(false);
        if (data === true && folioSaved !== null) {
          await folioSaved;
        }
        navigate(SEND_FOLIO, { replace: true });
        return;
      }, 1500);
    } else {
      setLoading2(false);
      setLoading3(false);
      if (isTogglePay === true) {
        setPaymentToggle(true);
      }
      // setErrorModalData4((state) => ({
      //   ...state,
      //   toggleError: true,
      //   errorMessage: t(
      //     "Check-out Not Allowed. Please visit front desk for assistance"
      //   ),
      // }));
      setTimeout(() => {
  setErrorModalData4((state) => ({
    ...state,
    toggleError: true,
    errorMessage: t(
      "Check-out Not Allowed. Please visit front desk for assistance"
    ),
  }));
}, 4000); // waits 4 seconds before showing modal after preauth modal
      setTimeout(() => {
        handlebackPage();
      }, 6000);
      return;
    }
  };

  const paymentTypeHandler = async (paymentMode, totalAmountDue, isPreauthExist) => {
    
    try {
      incrementI();
      if (paymentMode === undefined || paymentMode === null) {
        setLoading2(true);
      }

      const confirmNo = localStorage.getItem("confirmationNo");
      const ReservationNameID = localStorage.getItem("reservationNameID");

      const paymentType = {
        account: userData?.account,
        amount: Number.parseFloat(totalAmount).toFixed(2),
        poiID: deviceConfig, // deviceConfig,//deviceID.settingsValue,//"AMS1-000168230430477",
        currency: propertyData?.data?.currency,
        reservationNameID: ReservationNameID,
        pmsConfirmationNo: confirmNo,
        isCheckin: false,
        IsDebitCard: true, //direct
      };
      setIsPreauth(isPreauthExist);
      if (
        isSettleByPMS === true ||
        isPreauthExist === true ||
        isPreauthExist === "true"
      ) {
        //check if preauth exists in reservation if yes do checkout if not do direct transaction
        await doCheckout(true);
        //console.log("payment is settled in PMS OPI")
        return;
      }
      setFreezeTimer(true);
        <CheckoutFooter 
        freezeTimer={freezeTimer}
      />
      const response = await triggerPayment(paymentType, token);
      setFreezeTimer(false);
       <CheckoutFooter 
        freezeTimer={freezeTimer}
      />
      if (response?.data?.result) {
        if (paymentToggle === true) setLoading2(false);
        setLoading3(true);

        const paymentData = {
          pmsConfirmationNo: confirmNo,
          reservationNameID: ReservationNameID,
          postDate: new Date().toISOString(),
          amount: totalAmount,
          info: response?.data?.data?.refNumber,
          terminalID: deviceConfig, //"KIOSK",
          folioWindow: 1,
          //creditCardType: response?.data?.data?.cardType?.toUpperCase(),//"CA", //Use this in production
          creditCardType: response?.data?.data?.cardType?.toUpperCase() ?? "CA", //Use this in Developer Env
          creditCardNumber: response?.data?.data?.cardNumber ?? response?.data?.data?.maskedPAN,
          //creditCardNumber: response?.data?.data?.cardNumber, // "4151500000000008",
          creditCardExpiry:
            response?.data?.data?.cardExpiry !== null &&
              response?.data?.data?.cardExpiry !== undefined
              ? formatCardExpiry(response?.data?.data?.cardExpiry)
              : null,
          cardToken: response?.data?.data?.cardToken ?? response?.data?.data?.authID,
          //cardToken: response?.data?.data?.cardToken,
          preAuthRule: "",
          reference: "",
          isCheckin: false,
          IsDebitCard: true,
          // IsDebitCard: (paymentMode === 'debitcard')
        };

        const response3 = await postPaymentToPMS(paymentData, token);
        if (response3.status === 200 && response.data.result) {
          const RegCard = {
            reservationID: 0,
            confirmationNo: confirmNo,
            reservationNameID: ReservationNameID,
            signatureBase64: "-", //use saved signature in DB
            documentType: "FOLIO",
          };
          var folioSaved = saveFolio(RegCard, token);
          await doCheckout(null);
          await folioSaved;
        } else {
          if (i === 3) {
            setLoading3(false);
            if (isTogglePay === true) {
              setPaymentToggle(true);
            }
            setTimeout(() => {
              // extra delay before showing modal
              setTimeout(() => {
                setErrorModalData2((state) => ({
                  ...state,
                  toggleError: true,
                  errorMessage: t(
                    "Check-out Not Allowed. Please visit front desk for assistance"
                  ),
                }));
              }, 4000); // delay modal by 2s

              handlebackPage();
            }, 6000);

            return;
          } else {
            setLoading3(false);
            if (isTogglePay === true) {
              setPaymentToggle(true);
            }
            setTimeout(() => {
              setErrorModalData2((state) => ({
                ...state,
                toggleError: false,
                errorMessage: t(
                  "Payment unsuccessful. Please review your payment details and try again, or proceed to the front desk for assistance."
                ),
              }));
            }, 6000);
          }
        }
      } else {
        ;
        if (i === 3) {
          setLoading2(false);
          setLoading3(false);
          if (isTogglePay === true) {
            setPaymentToggle(true);
          }
          setTimeout(() => {
            setErrorModalData2((state) => ({
              ...state,
              toggleError: true,
              errorMessage: t(
                "Payment unsuccessful. Please visit front desk for assistance."
              ),
            }));

            setTimeout(() => {
              handlebackPage();
            }, 2000);

            // handlebackPage();
          }, 500);
          return;
        } else {
          addLog(
            JSON.stringify("Debit Payment triggered and returned false"),
            "false",
            `Payment failed, retrying...attempt: ${i + 1}`
          );

          console.log("Payment failed, retrying...attempt: " + i + 1);
          setLoading2(false);
          setLoading3(false);
          if (isTogglePay === true) {
            setPaymentToggle(true);
          }
          setTimeout(() => {
            setErrorModalData2((state) => ({
              ...state,
              toggleError: true,
              errorMessage: t(
                "Payment unsuccessful. Please review your payment details and try again, or proceed to the front desk for assistance."
              ),
            }));
          }, 500);
        }
      }
    } catch (error) {
      setLoading2(false);
      setLoading3(false);
      if (isTogglePay === true) {
        setPaymentToggle(true);
      }
      setErrorModalData2((state) => ({
        ...state,
        toggleError: true,
        errorMessage: t(
          "Payment unsuccessful. Please review your payment details and try again, or proceed to the front desk for assistance."
        ),
      }));
      console.log(error);
      return;
    }
  };
  const dispatch = useDispatch();
  const handlebackPage = () => {
    try {
      homePageHandler(dispatch, navigate);
    } catch (error) {
      console.error("Error returning back:", error);
    }
  };
  const addLog = (response, request, message) => {
    const confirmationNo = localStorage.getItem("confirmationNo");
    const data = {
      ActionName: "Checkout Payment",
      Message: message ?? "",
      ControllerName: "kiosk",
      Request: request ?? "",
      PMSConfirmationNo: confirmationNo,
      AppType: "kiosk",
      Response: response ?? "",
      PropertyCode: propertyData?.data?.propertyCode,
    };
    dispatch(postAuditLog({ data, token }));
  };
        //KC-447 Timer need to restart when user interaction is involved
        useUserActivity(() => {
          setTimerValue(timeLimit); 
        });
  return (
    <div>
      <Payment

        //closePreAuthModal={closePreAuthModal}
        isPreauth={isPreauth}
        loading={loading}
        loading2={loading2}
        loading3={loading3}
        userData={userData}
        erroModalData={erroModalData}
        erroModalData2={erroModalData2}
        erroModalData3={erroModalData3}
        generateToken={enablePaymentToggle}
        closeErrorModal={closeErrorModal}
        closeErrorModal2={closeErrorModal2}
        closeErrorModal3={closeErrorModal3}
        openModal={openModal}
        paymentToggle={paymentToggle}
        setPaymentToggle={setPaymentToggle}
        navigateUrl={SEND_FOLIO}
        userCheckIn={userCheckOut}
        paymentTypeHandler={paymentTypeHandler}
        successLoader={successLoader}
        successMessage={t("You have been successfully Checked-out")}
        erroModalData4={erroModalData4}
        closeErrorModal4={closeErrorModal4}
        property={propertyData?.data}
        totalDue={totalAmount}
        onBackPressed={handlebackPage}


      />
      <CheckoutFooter
        page={"payment"}
        showModal={showModal}
        openModal={openModal}
        timerCounter={timerCounter}
        timerValue={timerValue}
        restartTimer={restartTimer}
        stopTimer={stopTimer}
        timeLimit={timeLimit}
        freezeTimer={freezeTimer}
      />
      {showModal && (
        <HomePageCard
          showModal={showModal}
          resetTimerAndClosePopUp={resetTimerAndClosePopUp}
        />
      )}




    </div>
  );
};

export default CheckoutPayment;
